import React from 'react';
import './Guide.css';
import Arrow_Right from '../../data/img/Arrow - Right.png';
import blog1 from '../../data/img/b11.png';
import blog2 from '../../data/img/b22.png';
import blog3 from '../../data/img/b33.png';
import level from '../../data/img/Scrool Down.png';
import scrollBtn from '../../data/img/tobuttom.png';
import scroll_effect from '../../utils/scroll_effect';

const Guide = () => {
    scroll_effect('.guide-effect', 1.5)
    const scrollBottomToTop = ()=>{
        window.scrollTo({
            top: 7000,
            behavior: "smooth"
        })
    }
    return (
        <>
        <br />
            <div className="blog-aria">
            <div className="container">
                <div>
                    <div className="top-section">
                        <h2>A SHORT GUIDE</h2>
                        <div>
                            <p>Arbitrage is a superior and revolutionary solution for gaining money for the new generation. In today’s modern world, Arbitrage can become a new business model according to the current situation and the future of humankind in this dataism era.</p>
                            <button className="read-more-btn">
                                Read <p>More<img src={Arrow_Right} alt=""/></p>
                            </button>
                        </div>
                    </div>
                    <div className="button-section guide-effect">
                        <div>
                            <div>
                                <img src={blog1} alt=""/>
                                <h3>What is BVarb.com ?</h3>
                                <p>BVarb.com is a company and a platform that provides entertainment in terms of Arbitrage,staking,NFT,Altcoins,crypto sport </p>
                                <button className="read-more-btn">
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src={blog2} alt=""/>
                                <h3>How BVarb.com Works?</h3>
                                <p>BVarb.com is a company that makes Arbitrage & Arbing for the users and partners through very complex software and modern technologies as Artificial....</p>
                                <button className='read-more-btn'>
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src={blog3} alt=""/>
                                <h3>Registration Step by Step</h3>
                                <p>Get Started Now, Create your personal account as a first step to become a successful player. Are you ready to start earning with us?</p>
                                <button className="read-more-btn">
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div className='scroll-dow-container'>
                            <img className="scroll-img" src={level} alt=""/>
                            <br/>
                            <img onClick={scrollBottomToTop} className="mouse-img" src={scrollBtn} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
// Testimonials
export default Guide;